import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext from '../AppContext';
import { Organization } from '../viewModels/Organization';
import { Organization as GraphqlOrganization, ListOrganizationsPayload } from './generated/types';
import { mapToOrganizationListViewmodel } from './mappers/organization';


export const useOrganizations = () => {
    // const queryClient = useQueryClient();
    const context = useContext(AppContext);

    const query = `query ListOrganizations {
      listOrganizations {
        items {
          address
          city
          code
          contactEmail
          contactPerson
          contactPhone
          registration
          country
          name
          id
          isAllowedToUseLicenseSystemsOffline
          isHeadOrganization
          parentOrgId
          zip
          parentOrgData {
                id
                name
              }
        }
      }
    }`;

    return useQuery<Array<Organization>, any>({
        queryKey: ['listOrganizations'],
        queryFn: async () => {

            const response = await (context.api.graphql({ query }) as Promise<{
                data: {
                    listOrganizations: ListOrganizationsPayload;
                };
            }>);

            const result = mapToOrganizationListViewmodel(response.data.listOrganizations!.items as Array<GraphqlOrganization>);

            return result;
        },
        enabled: true,
    });
};
